export default __webpack_public_path__ + "static/media/ios-information-circle.e4a7838b.svg";